export default "__VITE_ASSET__DVWud9lT__"